import { useState, useRef } from 'react';
import cx from 'classnames';
import ReactPlayer from 'react-player/lazy';
import screenfull from 'screenfull';
import { ArrowsMaximize } from 'tabler-icons-react';
import { PlayPause, UserStoryCard, DownloadButton, Button } from 'Elements';
import styles from 'partials/videoclip.module.scss';

export const VideoClip = ({ video, className }) => {
	const [isPlaying, setIsPlaying] = useState(false);
	const player = useRef(null);

	const handlePlayPause = () => {
		setIsPlaying(!isPlaying);
	};

	const handleEnded = () => {
		setIsPlaying(false);
	};

	const handleFullscreen = () => {
		if (screenfull.isEnabled) screenfull.toggle(player.current.wrapper);
	};

	const overlayClass = cx(styles.imageIconBox, {
		[styles.imageIconBoxPlaying]: isPlaying
	});

	const cardClass = cx(styles.box, className);

	return (
		<div className={cardClass}>
			<div className={styles.imageBox}>
				<ReactPlayer
					ref={player}
					playing={!screenfull.isFullscreen && isPlaying}
					url={video?.file_url?.origin}
					controls={screenfull.isFullscreen}
					className={styles.player}
					width="100%"
					height="100%"
					onEnded={handleEnded}
				/>
				<div
					className={overlayClass}
					onClick={handlePlayPause}
					onKeyPress={handlePlayPause}
					role="button"
					tabIndex="0">
					<PlayPause
						size={24}
						className={styles.playIcon}
						isPlaying={!screenfull.isFullscreen && isPlaying}
						onPlayPause={handlePlayPause}
					/>
				</div>
				<div className={styles.fullscreen}>
					<Button
						onClick={handleFullscreen}
						className={styles.fullscreenBtn}>
						<ArrowsMaximize size={20} color="#fff" />
					</Button>
				</div>
			</div>
			<div className={styles.content}>
				<h3 className={styles.title}>{video.title}</h3>
				<div className={styles.meta}>
					<div className={styles.metaRight}>
						<UserStoryCard user={video.user} />
					</div>
					<div className={styles.metaLeft}>
						<span className={styles.duration}>
							{video.file_time}
						</span>
						<DownloadButton
							url={video?.file_url?.origin}
							size={video?.file_size}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
